export default __webpack_public_path__ + "static/media/b5.99c9b683.jpg";